// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperClaiming-cls1_VVu","cls2":"PaperClaiming-cls2_opz PaperClaiming-cls1_VVu"};